export default {
  bind(el) {
    el.addEventListener("click", toggleActiveClassOnButton);
  },

  unbind(el) {
    el.removeEventListener("click", toggleActiveClassOnButton);
  }
};

/**
 * Sets or removes active class on button click
 * @param { object } evt Click event
 */
function toggleActiveClassOnButton(evt) {
  if (evt.currentTarget.nodeName === "BUTTON") {
    evt.currentTarget.classList.toggle("button-active");
  }
}
